import React from "react";
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import{FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About =() => {
    return(
    <section id="about">
        <h5>Get To Know</h5>
        <h2>About Me</h2>
        <div className="container about__container">

            <div className="about__me">
                <div className="about__me-image">
                    <img src={ME} alt="ABOUT IMAGE" />
                </div>

            </div>
            <div className="about__content">
                <div className="about__cards">
                    <article className="about__card">
                       <FaAward className="about__icon"/>
                        <h5>Experience</h5>
                        <small>1 Year Experience</small>
                    </article>
                    <article className="about__card">
                       <FiUsers className="about__icon"/>
                        <h5>Clients</h5>
                        <small>10+ Clients</small>
                    </article>
                    <article className="about__card">
                       <VscFolderLibrary className="about__icon"/>
                        <h5>Projects</h5>
                        <small>20+ Completed</small>
                    </article>
                </div>
                <p>
                "Highly motivated and detail-oriented Full-Stack Developer with 3+ years of experience in developing and deploying web applications.
                 Proficient in JavaScript, React, Node.js, Express, and MongoDB. Adept at creating dynamic, 
                 user-friendly websites and ensuring optimal performance, scalability, and security. Strong problem-solving skills,
                  ability to work in a fast-paced environment, and excellent communication and collaboration skills. 
                Committed to delivering high-quality solutions and continuously learning and improving technical abilities."
                </p>

<a href="#contact" className='btn btn-primary'>Let's Talk</a>
            </div>
        </div>
    </section>
    )
}

export default About